import ListagemParcelas from "@/components/ListagemParcelas";
import { ehAreaLogadaCliente, ehAreaParceiro } from "@/services/ambiente";
import { get } from "@/services/api";
import { get as getParceiro } from "@/services/apiParceiro";
import { formatMonetario } from "@/services/utils";
import {
  activeSpinner,
  cancelSpinner,
  setInfoDialog,
} from "@/store/reducers/geral";
import { Typography } from "@mui/material";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid2";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import "./ResultadoSimulacao.scss";

export default function ResultadoSimulacao({
  esconderValores,
  exibirComissao,
  contratar,
  billValue,
  idComissionTable,
  reverseSimulator,
  requestPriority,
  setOpcaoParcelamento,
  cupomUtilizar,
  idUser,
  idCompany,
  idRequest,
  token,
  carregarSimulacao,
  setCarregarSimulacao,
  exportRef,
}) {
  const dispatch = useDispatch();
  const [deveConfirmar, setDeveConfirmar] = useState(false);
  const [parcelas, setParcelas] = useState([]);
  const [valorSimulado, setValorSimulado] = useState(0);
  const [orderSimulations, setOrderSimulations] = useState("");

  useEffect(() => {
    const executaSimulacao = async () => {
      try {
        dispatch(activeSpinner());
        let urlParams = `?1=1`;
        urlParams += `&idUser=${idUser || ""}`;
        urlParams += `&idComissionTable=${idComissionTable || ""}`;
        urlParams += `&idCompany=${idCompany || ""}`;
        urlParams += `&idRequest=${idRequest || ""}`;
        urlParams += `&orderSimulations=${orderSimulations || ""}`;
        urlParams += `&token=${token || ""}`;
        if (reverseSimulator === "S") {
          urlParams += `&creditLimit=${billValue}`;
        } else {
          urlParams += `&billValue=${billValue}`;
        }

        let result;
        if (ehAreaParceiro()) {
          urlParams += `&requestPriority=${requestPriority ? "Y" : "N"}`;
          let url;
          if (reverseSimulator === "S") {
            url = `secure/requests/simulate-credit-limit${urlParams}`;
          } else {
            url = `secure/requests/simulate${urlParams}`;
          }
          result = await getParceiro(url);
        } else {
          urlParams += `&cupom=${cupomUtilizar || ""}`;
          if (ehAreaLogadaCliente()) {
            result = await get(`secure/requests/simulate${urlParams}`);
          } else {
            result = await get(`public/simulate${urlParams}`);
          }
        }
        dispatch(cancelSpinner());
        if (result.error) {
          dispatch(
            setInfoDialog({
              open: true,
              descricao: result.error,
            })
          );
          return;
        }
        setValorSimulado(billValue);
        setParcelas(result);
        if (result.length > 0) {
          setOrderSimulations(result[0].orderSimulations);
        }
      } catch (e) {
        console.log(e);
        dispatch(cancelSpinner());
        dispatch(
          setInfoDialog({
            open: true,
            descricao:
              "Ocorreu um erro ao simular! Tente novamente em instantes.",
          })
        );
      }
    };

    if (carregarSimulacao && billValue) {
      setCarregarSimulacao(false);
      executaSimulacao();
    }
  }, [
    billValue,
    cupomUtilizar,
    requestPriority,
    setCarregarSimulacao,
    orderSimulations,
    idComissionTable,
    reverseSimulator,
    idUser,
    carregarSimulacao,
    idRequest,
    idCompany,
    token,
    dispatch,
  ]);

  useEffect(() => {
    if (deveConfirmar) {
      setDeveConfirmar(false);
      contratar();
    }
  }, [deveConfirmar, contratar]);

  return (
    <>
      <Container maxWidth="md">
        <Grid container>
          <Grid item size={12} align="center">
            <Typography>
              Valor simulado: {formatMonetario(valorSimulado)}
            </Typography>
          </Grid>
        </Grid>
        <ListagemParcelas
          {...{
            parcelas,
            setDeveConfirmar,
            setOpcaoParcelamento,
            reverseSimulator: reverseSimulator,
            exibirComissao,
            esconderValores,
            idCompany,
            exportRef,
          }}
        />
      </Container>
    </>
  );
}
